/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Grower_File_Attach_ErrorInputs */

const vi_toast_grower_file_attach_error = /** @type {(inputs: Toast_Grower_File_Attach_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đính kèm giấy tờ thất bại`)
};

/**

* @param {Toast_Grower_File_Attach_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_grower_file_attach_error = /** @type {((inputs?: Toast_Grower_File_Attach_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Grower_File_Attach_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_grower_file_attach_error(inputs)
});